import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/heldenstrom/heldenstrom/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/runner/work/heldenstrom/heldenstrom/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/heldenstrom/heldenstrom/node_modules/next/dist/client/image-component.js");
